import CONSTANTS from '../constants';
import AppService from './appService';
import CacheService from './cacheService';
import axios from 'axios';

export default {
    checkEmail,
    signUp,
	login,
	logout,
    forgotPassword,
    resetPassword,
    changePassword,
	getProfile,
	getMemberships,
	getMembership,
	getAccounts,
    getAccount
};

function checkEmail(bname, email) {
    return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.MEMBER.SIGN_UP.CHECK_EMAIL}?email=${email}`, {
        headers: {
            'Business-Name': bname,
        }});
}

async function signUp(params) {
    return axios.post(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.MEMBER.SIGN_UP.COMPLETE_SIGN_UP}`,{
        email:         params.email,
        first_name:    params.first_name,
        last_name:     params.last_name,
        primary_phone: params.primary_phone,
        address:       params.address,
        city:          params.city,
        state:         params.state,
        zip:           params.zip
    }, {
        headers: {
            'Business-Name': params.bname,
            'Password': params.password,
            'Password-Confirmation': params.password_confirmation
        }});
}

function login(bname, email, password) {
	return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.MEMBER.LOGIN}`, {
		headers: {
			'Business-Name': bname,
			'Email': email,
			'Password': password
		}});
}

function logout() {
    CacheService.removeToken();
}

async function forgotPassword(bname, email) {
    let checkEmail = await axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.MEMBER.SIGN_UP.CHECK_EMAIL}?email=${email}`, {
        headers: {
            'Business-Name': bname,
        }});
    if(checkEmail.data.success) {
        return axios.post(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.MEMBER.SET_RESET_PASSWORD_TOKEN}`, {}, {
            headers: {
                'Business-Name': bname,
                'Email': email
            }});
    }
    return checkEmail
}

async function resetPassword(bname, email, resetPasswordToken, newPassword, passwordConfirmation) {
    return axios.post(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.MEMBER.RESET_PASSWORD}`, {}, {
        headers: {
            'Business-Name': bname,
            'Email': email,
            'Reset-Password-Token': resetPasswordToken,
            'New-Password': newPassword,
            'Password-Confirmation': passwordConfirmation
        }});
}

async function changePassword(oldPassword, newPassword, passwordConfirmation) {
    let newAccessToken = await AppService.refreshAccessToken();
    return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.MEMBER.CHANGE_PASSWORD}`, {
        headers: {
            'Business-Name': CacheService.getToken().bname,
            'Access-Token': newAccessToken,
            'Old-Password': oldPassword,
            'New-Password': newPassword,
            'Password-Confirmation': passwordConfirmation
        }});
}

async function getProfile() {
	let newAccessToken = await AppService.refreshAccessToken();
	return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.MEMBER.PROFILE}`, {
		headers: {
			'Business-Name': CacheService.getToken().bname,
			'Access-Token': newAccessToken
		}});
}

async function getMemberships() {
    let newAccessToken = await AppService.refreshAccessToken();
	return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.MEMBER.MEMBERSHIPS}`, {
		headers: {
			'Business-Name': CacheService.getToken().bname,
			'Access-Token': newAccessToken
		}});
}

async function getMembership(membershipId) {
    let newAccessToken = await AppService.refreshAccessToken();
    return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.MEMBER.MEMBERSHIPS}/${membershipId}`, {
        headers: {
            'Business-Name': CacheService.getToken().bname,
            'Access-Token': newAccessToken
        }});
}

async function getAccounts() {
    let newAccessToken = await AppService.refreshAccessToken();
    return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.MEMBER.ACCOUNTS}`, {
        headers: {
            'Business-Name': CacheService.getToken().bname,
            'Access-Token': newAccessToken
        }});
}

async function getAccount(accountId) {
    let newAccessToken = await AppService.refreshAccessToken();
    return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.MEMBER.ACCOUNTS}/${accountId}`, {
        headers: {
            'Business-Name': CacheService.getToken().bname,
            'Access-Token': newAccessToken
        }});
}



// WEBPACK FOOTER //
// ./src/services/memberService.js